var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUnlink48Line = function SvgIconUnlink48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.51 14.55A6.22 6.22 0 0 1 29 12.7a6.34 6.34 0 0 1 4.5 10.79l-3.75 3.71 2.4 2.4 3.71-3.71a9.724 9.724 0 0 0-6.875-16.598 9.723 9.723 0 0 0-6.875 2.848l-3.71 3.71 2.4 2.4 3.71-3.7ZM23.49 33.45a6.299 6.299 0 0 1-8.91 0 6.289 6.289 0 0 1 0-8.91l3.71-3.71-2.41-2.4-3.71 3.71a9.71 9.71 0 0 0 0 13.7 9.72 9.72 0 0 0 13.71 0l3.71-3.71-2.4-2.4-3.7 3.72ZM38.87 29.72h-5v3.4h5v-3.4ZM33.12 33.87h-3.4v5h3.4v-5ZM18.28 9.13h-3.4v5h3.4v-5ZM14.13 14.88h-5v3.4h5v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconUnlink48Line;